module.exports = __webpack_public_path__ + "img/img_level_9.be96c9e2.png";